const CONSOLE_BASE_URL =
    location.origin.includes('test') || location.origin.includes('dev')
        ? 'https://console-dev-lane.xiaoduoai.com'
        : 'https://console.xiaoduoai.com'

const ENTERPRISE_BASE_URL =
    location.origin.includes('test') || location.origin.includes('dev')
        ? 'https://enterprise-dev-lane.xiaoduoai.com'
        : 'https://enterprise.xiaoduoai.com'

export {
    CONSOLE_BASE_URL,
    ENTERPRISE_BASE_URL
}